// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","card__img":"Card_card__img__gl4P4","card__title":"Card_card__title__amdqM","card__genres":"Card_card__genres__lhhdG"};